import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-request-error',
  templateUrl: './request-error.component.html',
  styles: [
  ]
})
export class RequestErrorComponent extends BaseComponent implements OnInit {
  code: string;
  errorMsgKey: string;

  constructor(private cookieService: CookieService,
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe( params => {
      this.code = params['error_code'];

      if (this.code === '16') {
        this.errorMsgKey = "bss.api.error.16";
      } else {
        this.errorMsgKey = "bss.request.error.message";
      }
    });
  }

  onSubmit() {
    window.location.href = '/opsbpssecure/';
  }
}
